
import { useMediaQuery } from 'react-responsive';

/**
 * Custom hook to manage various media queries
 * @returns An object containing boolean values for different media queries
 */
function useMediaQueries() {
    const isBigScreen1 = useMediaQuery({ query: '(min-width: 1401px)' });
    const isBigScreen2 = useMediaQuery({ query: '(min-width: 1624px)' });
    const isDesktop = useMediaQuery({ query: '(min-width: 1366px)' });
    const isDesktopSmaller = useMediaQuery({ query: '(max-width: 1200px)' });
    const isDesktopSmall = useMediaQuery({ query: '(min-width: 1024px)' });
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const isMobileMini = useMediaQuery({ query: '(max-width: 375px)' });
    const isTablet = useMediaQuery({
        query: '(min-width: 767px) and (max-width: 1024px)',
    });
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    const isIpadAirLS = useMediaQuery({
        query: '(min-width: 1180px) and (max-width: 1180px) and (max-height: 820px) and (min-height: 820px)',
    });
    const iPadProLandscape = useMediaQuery({
        query: '(min-width: 768px) and (max-width: 1024px)',
    });
    const iPadProPortrait = useMediaQuery({
        query: '(min-width: 1024px) and (max-width: 1366px)',
    });
    const isMobileLandscape = useMediaQuery({
        query: '(min-width: 667px) and (max-height: 414px)',
    });

    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' });
    return {
        isBigScreen1,
        isBigScreen2,
        isDesktop,
        isDesktopSmaller,
        isDesktopSmall,
        isMobile,
        isMobileMini,
        isTablet,
        isTabletOrMobile,
        isPortrait,
        isRetina,
        iPadProLandscape,
        iPadProPortrait,
        isIpadAirLS,
        isMobileLandscape,
    };
}

export default useMediaQueries;